import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';
import Loader from '../components/Loader';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { request } from '../functions/apiRequestWrapper';
import { PATH_OFFERS } from '../constants';
import { DateTime } from 'luxon';
import sanitizeHtml from 'sanitize-html';

import { connect } from 'react-redux';
import { logout } from '../redux/User';
const mapDispatchToProps = dispatch => {
    return {
        logout: () => { dispatch(logout()); }
    }
}

class Offers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            list: [],
            error: null
        };
    }

    componentDidMount() {
        setTimeout(() => {window.scrollTo(0, 0);}, 100);
        let today = DateTime.now().toISODate();
        request(
            `${process.env.REACT_APP_API}/1/cms/offers?$orderby=closingDate asc&$filter=cast(closingDate, 'Edm.DateTimeOffset') ge ${today}`
        ).then((data) => {
            // console.log(data);
            this.setState({list: data, isLoading: false});
        }).catch((error) => {
            console.error(error);
            if (error.status === 401) { this.props.logout(); }
            let msg = "An error has occured";
            if (error.body && error.body.message) {
                msg = error.body.message;
            }
            this.setState({error: msg, isLoading: false});
        });
    }

    render() {
        const {list, isLoading, error} = this.state;
        return (
            <div className="page offers container px-3 px-md-5">
                <Breadcrumb>Offers</Breadcrumb>
                <h2 className="mb-3">Offers</h2>

                {(!isLoading && error) && <p className="alert alert-danger my-5">{error}</p>}

                <div className="list offers position-relative">
                    {isLoading && <Loader type={list && list.length > 0 ? "overlay" : "placeholder"} />}
                    <div className="row">
                        
                        {(!list || list.length === 0) && <h2 className="text-center py-5">There are no current offers.</h2>}
                        
                        {list && list.map((offer, i) => {
                            let text = sanitizeHtml(offer.description, {allowedTags: [], allowedAttributes: {}});
                            let available = "Available until " + DateTime.fromISO(offer.closingDate).toLocaleString({day: 'numeric', month: 'long', year: 'numeric'});
                            if (i === 0) {
                                return (
                                    <div className="col-12" key={offer.id}>
                                        <div className="row mb-5 offer-featured-item">
                                            <div className="col-12 col-sm-6 col-md-8">
                                                <div className="featured-img d-sm-none d-lg-block" style={{backgroundImage: `url("${offer.image}")`}} />
                                                <div className="featured-img d-none d-sm-block d-lg-none" style={{backgroundImage: `url("${offer.thumbnail || offer.image}")`}} />
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-4">
                                                <div className="py-2 py-sm-5 px-sm-2 px-md-3">
                                                    <h3><b>{offer.title}</b></h3>
                                                    <p className="featured-subtitle">{available}</p>
                                                    <div className="featured-desc mb-4">{text}</div>
                                                    <Button variant="primary" as={Link} to={`${PATH_OFFERS}/${offer.slug}`}>Read more</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                            return (
                                <div className="col-6 col-md-4 col-lg-3" key={offer.id}>
                                    <Link to={`${PATH_OFFERS}/${offer.slug}`} className="offer-list-item d-block mb-5">
                                        <Card>
                                            <div className="card-img-top square" style={{backgroundImage: `url("${offer.thumbnail || offer.image}")`}} />
                                            <Card.Body>
                                                <Card.Title>{offer.title}</Card.Title>
                                                <Card.Subtitle className="mb-2">{available}</Card.Subtitle>
                                                <Card.Text>{text}</Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Link>
                                </div>
                            );
                        })}
                        
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(undefined, mapDispatchToProps)(Offers);
